// Careers App Index
// Routes to the job application queue and individual application detail pages

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';
import ApplicationDetail from './ApplicationDetail';

const CareersApp = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="careers:read">
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/:id"
        element={
          <ProtectedRoute requiredPermission="careers:read">
            <ApplicationDetail />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/careers" replace />} />
    </Routes>
  );
};

export default CareersApp;
